//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import {
  mdiArrowTopLeft,
  mdiArrowUp,
  mdiArrowTopRight,
  mdiArrowBottomRight,
  mdiArrowDown,
  mdiArrowBottomLeft,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowCollapseAll,
} from '@mdi/js'

export default {
  setup() {
    const isSnackbarTopLeftVisible = ref(false)
    const isSnackbarTopVisible = ref(false)
    const isSnackbarTopRightVisible = ref(false)
    const isSnackbarBottomRightVisible = ref(false)
    const isSnackbarBottomVisible = ref(false)
    const isSnackbarBottomLeftVisible = ref(false)
    const isSnackbarRightVisible = ref(false)
    const isSnackbarLeftVisible = ref(false)
    const isSnackbarCenteredVisible = ref(false)

    return {
      isSnackbarTopLeftVisible,
      isSnackbarTopVisible,
      isSnackbarTopRightVisible,
      isSnackbarRightVisible,
      isSnackbarLeftVisible,
      isSnackbarBottomRightVisible,
      isSnackbarBottomVisible,
      isSnackbarBottomLeftVisible,
      isSnackbarCenteredVisible,

      // icons
      icons: {
        mdiArrowTopLeft,
        mdiArrowUp,
        mdiArrowTopRight,
        mdiArrowBottomRight,
        mdiArrowDown,
        mdiArrowBottomLeft,
        mdiArrowLeft,
        mdiArrowRight,
        mdiArrowCollapseAll,
      },
    }
  },
}
